(function () {
  // ===== Plan picker (syncs visual + radio input + sticky price) =====
  const plans = document.querySelectorAll('.plan');
  const stickyPrice = document.getElementById('stickyPrice');
  plans.forEach(p => {
    p.addEventListener('click', (e) => {
      // Don't double-fire if click was on the label's native input
      if (e.target.tagName === 'INPUT') return;
      plans.forEach(x => {
        x.classList.remove('selected');
        x.setAttribute('aria-checked', 'false');
        const r = x.querySelector('input[type="radio"]');
        if (r) r.checked = false;
      });
      p.classList.add('selected');
      p.setAttribute('aria-checked', 'true');
      const radio = p.querySelector('input[type="radio"]');
      if (radio) radio.checked = true;
      if (stickyPrice) {
        const label = p.dataset.stickyLabel || p.querySelector('.plan-title')?.textContent || '';
        const price = p.querySelector('.plan-price strong')?.textContent || '';
        stickyPrice.textContent = (price && label) ? `${price} · ${label}` : (price || label);
      }
      // Mirror the selected plan's price into the price row above the CTA
      const priceRow = document.querySelector('[data-price-row]');
      if (priceRow) {
        const priceNow = priceRow.querySelector('[data-price]');
        const priceCompare = priceRow.querySelector('[data-compare]');
        const priceSave = priceRow.querySelector('[data-save]');
        if (priceNow && p.dataset.price) priceNow.textContent = p.dataset.price;
        if (priceCompare) {
          if (p.dataset.compare) { priceCompare.textContent = p.dataset.compare; priceCompare.hidden = false; }
          else priceCompare.hidden = true;
        }
        if (priceSave) {
          if (p.dataset.save) { priceSave.textContent = p.dataset.save; priceSave.hidden = false; }
          else priceSave.hidden = true;
        }
      }
    });
  });

  // ===== Gallery thumbs =====
  const thumbs = document.querySelectorAll('.thumb');
  const main = document.getElementById('galleryMain');
  const mainImg = document.getElementById('galleryMainImg');
  const cssBgs = {
    1: 'linear-gradient(135deg, #2a1818, #5a2a1a)',
    2: 'radial-gradient(circle at 50% 50%, #ff5a3d, #8a1a1a 80%)',
    3: 'linear-gradient(160deg, #F5EDDF, #d9b89a)',
    4: 'linear-gradient(135deg, #1a0e0a, #3a1a14)'
  };
  thumbs.forEach((t, i) => {
    t.addEventListener('click', () => {
      thumbs.forEach(x => x.classList.remove('active'));
      t.classList.add('active');
      if (mainImg && t.dataset.src) {
        mainImg.src = t.dataset.src;
        if (t.dataset.srcset) mainImg.srcset = t.dataset.srcset;
      } else if (main) {
        main.style.background = cssBgs[i + 1];
      }
    });
  });

  // ===== FAQ accordion =====
  document.querySelectorAll('.faq-item').forEach(item => {
    const q = item.querySelector('.faq-q');
    if (!q) return;
    q.addEventListener('click', () => {
      const isOpen = item.classList.contains('open');
      document.querySelectorAll('.faq-item.open').forEach(o => {
        if (o !== item) {
          o.classList.remove('open');
          o.querySelector('.faq-q')?.setAttribute('aria-expanded', 'false');
        }
      });
      item.classList.toggle('open', !isOpen);
      q.setAttribute('aria-expanded', String(!isOpen));
    });
  });

  // ===== Review filter =====
  const chips = document.querySelectorAll('.chip');
  const cards = document.querySelectorAll('#reviewGrid .review-card');
  chips.forEach(c => {
    c.addEventListener('click', () => {
      chips.forEach(x => x.classList.remove('active'));
      c.classList.add('active');
      const f = c.dataset.filter;
      cards.forEach(card => {
        const tags = card.dataset.tags || '';
        card.style.display = (f === 'all' || tags.includes(f)) ? '' : 'none';
      });
    });
  });

  // ===== Sticky ATC visibility =====
  const sticky = document.getElementById('stickyAtc');
  const hero = document.getElementById('buy');
  if (sticky && hero && 'IntersectionObserver' in window) {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(e => {
        sticky.classList.toggle('visible', !e.isIntersecting);
      });
    }, { rootMargin: '-100px 0px 0px 0px' });
    observer.observe(hero);
  }

  // Sticky ATC button scrolls to buybox (form submission happens in the hero form)
  document.getElementById('stickyAtcBtn')?.addEventListener('click', () => {
    document.getElementById('buy')?.scrollIntoView({ behavior: 'smooth' });
  });

  // ===== Cart drawer =====
  const drawer = document.getElementById('cartDrawer');
  const itemsEl = document.getElementById('cartItems');
  const emptyEl = document.getElementById('cartEmpty');
  const footerEl = document.getElementById('cartFooter');
  const subtotalEl = document.getElementById('cartSubtotal');

  const formatMoney = (cents) => {
    const n = Number(cents) / 100;
    try { return n.toLocaleString('en-US', { style: 'currency', currency: (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'USD' }); }
    catch { return '$' + n.toFixed(2); }
  };

  const sizedImage = (url, size = '120x') => {
    if (!url) return '';
    return url.replace(/(\.(?:jpg|jpeg|png|webp|gif))(\?.*)?$/i, `_${size}$1$2`);
  };

  const escapeHtml = (s) => String(s == null ? '' : s).replace(/[&<>"']/g, c => ({ '&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;' }[c]));

  function openCart() {
    if (!drawer) return;
    drawer.classList.add('open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }

  function closeCart() {
    if (!drawer) return;
    drawer.classList.remove('open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  function renderCart(cart) {
    if (!itemsEl || !emptyEl || !subtotalEl || !footerEl) return;
    if (cart.item_count === 0) {
      itemsEl.innerHTML = '';
      itemsEl.hidden = true;
      footerEl.hidden = true;
      emptyEl.hidden = false;
      return;
    }
    emptyEl.hidden = true;
    itemsEl.hidden = false;
    footerEl.hidden = false;
    itemsEl.innerHTML = cart.items.map(item => {
      const variant = item.variant_title && item.variant_title !== 'Default Title' ? `<div class="cart-item-variant">${escapeHtml(item.variant_title)}</div>` : '';
      const img = item.image ? `<img class="cart-item-img" src="${escapeHtml(sizedImage(item.image, '160x'))}" alt="">` : `<div class="cart-item-img"></div>`;
      return `
        <div class="cart-item" data-key="${escapeHtml(item.key)}">
          ${img}
          <div class="cart-item-info">
            <div class="cart-item-title">${escapeHtml(item.product_title)}</div>
            ${variant}
            <div class="cart-item-qty">
              <button class="cart-qty-btn" type="button" data-qty-change data-key="${escapeHtml(item.key)}" data-qty="${item.quantity - 1}" aria-label="Decrease quantity">−</button>
              <span class="cart-qty-value">${item.quantity}</span>
              <button class="cart-qty-btn" type="button" data-qty-change data-key="${escapeHtml(item.key)}" data-qty="${item.quantity + 1}" aria-label="Increase quantity">+</button>
            </div>
            <div><button class="cart-item-remove" type="button" data-qty-change data-key="${escapeHtml(item.key)}" data-qty="0">Remove</button></div>
          </div>
          <div class="cart-item-price">${formatMoney(item.final_line_price)}</div>
        </div>`;
    }).join('');
    subtotalEl.textContent = formatMoney(cart.total_price);
  }

  async function refreshCart() {
    try {
      const r = await fetch('/cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' });
      if (!r.ok) return;
      const cart = await r.json();
      renderCart(cart);
    } catch (_) {}
  }

  // Close handlers
  document.querySelectorAll('[data-cart-close]').forEach(el => el.addEventListener('click', closeCart));
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && drawer?.classList.contains('open')) closeCart(); });

  // Quantity / remove handlers (event delegation inside drawer)
  itemsEl?.addEventListener('click', async (e) => {
    const btn = e.target.closest('[data-qty-change]');
    if (!btn) return;
    const key = btn.dataset.key;
    const qty = parseInt(btn.dataset.qty, 10);
    if (Number.isNaN(qty)) return;
    btn.disabled = true;
    try {
      await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        credentials: 'same-origin',
        body: JSON.stringify({ id: key, quantity: Math.max(0, qty) })
      });
      await refreshCart();
    } catch (_) { btn.disabled = false; }
  });

  // Intercept any product form to use AJAX + open drawer
  document.querySelectorAll('form[action$="/cart/add"], form.buybox-form').forEach(form => {
    form.addEventListener('submit', async (e) => {
      e.preventDefault();
      const submit = form.querySelector('button[type="submit"]');
      const original = submit ? submit.innerHTML : null;
      if (submit) { submit.disabled = true; submit.classList.add('is-loading'); submit.innerHTML = 'Adding…'; }
      try {
        const fd = new FormData(form);
        const r = await fetch('/cart/add.js', {
          method: 'POST',
          body: fd,
          headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          credentials: 'same-origin'
        });
        if (!r.ok) {
          const err = await r.json().catch(() => ({}));
          alert(err.description || err.message || 'Could not add to cart. Please try again.');
          return;
        }
        await refreshCart();
        openCart();
      } catch (_) {
        alert('Network error. Please try again.');
      } finally {
        if (submit) {
          submit.disabled = false;
          submit.classList.remove('is-loading');
          if (original != null) submit.innerHTML = original;
        }
      }
    });
  });

  // Cart contents fetched on first ATC click (refreshCart runs before openCart),
  // not eagerly on page load — saves an idle /cart.js request per pageview.

  // ===== V2 rolling 12-hour countdown =====
  (function () {
    if (!document.querySelector('[data-tr-countdown]')) return;
    const TIMER_KEY = 'tr_v2_countdown_end';
    const TIMER_MS = 12 * 60 * 60 * 1000;

    function endTime() {
      let end;
      try { end = parseInt(localStorage.getItem(TIMER_KEY) || '', 10); } catch (_) { end = NaN; }
      const now = Date.now();
      if (!end || isNaN(end) || end <= now) {
        end = now + TIMER_MS;
        try { localStorage.setItem(TIMER_KEY, String(end)); } catch (_) {}
      }
      return end;
    }

    const targets = {
      h: document.querySelectorAll('[data-tr-timer="h"]'),
      m: document.querySelectorAll('[data-tr-timer="m"]'),
      s: document.querySelectorAll('[data-tr-timer="s"]'),
    };
    function pad(n) { return String(n).padStart(2, '0'); }

    function tick() {
      let diff = Math.max(0, endTime() - Date.now());
      const h = Math.floor(diff / 3600000); diff %= 3600000;
      const m = Math.floor(diff / 60000); diff %= 60000;
      const s = Math.floor(diff / 1000);
      targets.h.forEach(el => el.textContent = pad(h));
      targets.m.forEach(el => el.textContent = pad(m));
      targets.s.forEach(el => el.textContent = pad(s));
    }
    tick();
    setInterval(tick, 1000);
  })();

  // ===== Reveal on scroll =====
  if ('IntersectionObserver' in window) {
    const reveals = document.querySelectorAll('.reveal');
    const revObs = new IntersectionObserver(entries => {
      entries.forEach(e => {
        if (e.isIntersecting) {
          e.target.classList.add('in');
          revObs.unobserve(e.target);
        }
      });
    }, { threshold: 0.12 });
    reveals.forEach(r => revObs.observe(r));
  }
})();
